import React, { useState } from 'react';
import styles from '../styles/panelList.module.css';
import { t } from '../i18n/translate';

interface PanelItem {
  text: string;
}

interface PanelListTextProps {
  title: string;
  subtext: string;
  items: PanelItem[];
  isExpanded?: boolean;
  iconUrl?: string;
  accentColor?: string;
  showItemCount?: boolean;
}

const PanelListText: React.FC<PanelListTextProps> = ({
  title,
  subtext,
  items,
  isExpanded = false,
  iconUrl,
  accentColor = '#4CAF50',
  showItemCount = true
}) => {
  const [expanded, setExpanded] = useState(isExpanded);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const headerStyle: React.CSSProperties = accentColor ? {
    borderLeft: `4px solid ${accentColor}`
  } : {};

  return (
    <div className={styles.panel}>
      <div 
        className={styles.panelHeader} 
        onClick={toggleExpanded}
        style={headerStyle}
      >
        <div className={styles.panelTitleSection}>
          <div className={styles.panelTitleRow}>
            {iconUrl && (
              <img 
                src={iconUrl} 
                alt="" 
                className={styles.panelIcon}
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
            )}
            <div className={styles.panelTitleContent}>
              <div className={styles.panelTitleRowTop}>
                <h3 className={styles.panelTitle}>{title}</h3>
                {showItemCount && items.length > 0 && (
                  <span className={styles.itemCountBadge}>{items.length}</span>
                )}
              </div>
              {subtext && <p className={styles.panelSubtext}>{subtext}</p>}
            </div>
          </div>
        </div>
        <button 
          className={`${styles.expandButton} ${expanded ? styles.expanded : ''}`}
          aria-label={expanded ? t('ui.COLLAPSE') : t('ui.EXPAND')}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      </div>
      
      {expanded && (
        <div className={styles.panelContent}>
          <div className={styles.textList}>
            {items.map((item, index) => (
              <div key={index} className={styles.textListItem}>
                <div className={styles.quoteIcon}>"</div>
                <p className={styles.quoteText}>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PanelListText;



